import { render, staticRenderFns } from "./RziFito.vue?vue&type=template&id=6c73d06c&"
import script from "./RziFito.vue?vue&type=script&lang=js&"
export * from "./RziFito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports